import type { JSX } from 'solid-js';
import { Button } from './ui/Button';

// The funnel's one button. Presenter. The step's forward action is `brand` — the
// view's one accent-filled CTA (owner ruling 2026-09-16); a `secondary` one (the
// plan step's "Just me", the yml copies) is `outline`.
//
// `aria-disabled` + a click guard, never `disabled`: disabling the focused
// button mid-advance drops keyboard focus to <body>. That rule was copy-pasted
// into every branch of the panel's footer, and its own test says so ("the guard
// is duplicated per branch — pin every one of them"). It is one component now,
// so a branch added later cannot forget it.
export type OnboardingAdvanceButtonProps = {
  readonly label: string;
  /** A write is in flight — the guard holds, the button keeps focus. */
  readonly busy: boolean;
  /**
   * The step's own precondition isn't met (no repo enabled yet). Distinct from
   * `busy` so the copy explaining WHY can sit beside the control rather than
   * being inferred from a greyed-out button.
   */
  readonly blocked?: boolean;
  readonly secondary?: boolean;
  readonly onAct: () => void;
};

export function OnboardingAdvanceButton(props: OnboardingAdvanceButtonProps): JSX.Element {
  const held = (): boolean => props.busy || props.blocked === true;
  return (
    <Button
      variant={props.secondary ? 'outline' : 'brand'}
      aria-disabled={held()}
      onClick={() => {
        if (!held()) props.onAct();
      }}
    >
      {props.label}
    </Button>
  );
}
